import script from "./HistoricProjectEstimateComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoricProjectEstimateComponent.vue?vue&type=script&lang=ts&setup=true"

import "./HistoricProjectEstimateComponent.vue?vue&type=style&index=0&id=daa2276e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daa2276e"]])

export default __exports__